export default {"src":"/pro/_next/static/media/wsteth.78e46471.svg","height":293,"width":293,"blurWidth":0,"blurHeight":0};